import { HttpMethods, RequestPerformer } from '@/api/api-requests-factory';
import { Ref } from 'vue';
import { GetAdminRequest } from '@/api/admin/get-admin.requests';

export class AdminApiResources {
  constructor(
    private readonly requestPerformer: RequestPerformer,
    private readonly multibrandApiHost: Ref<string>,
  ) {}

  getAdminRequest(): GetAdminRequest {
    return new GetAdminRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/backofficeapi/admin/me`,
      HttpMethods.GET,
    );
  }
}
